import React from 'react';
import {color as themeColors} from '../../Theme';
import {asREM} from '../../Utilities';

export function RsnSpinner({
    w: width = '100%',
    h: height = '100%',
    color = 'neutral100',
    customColor,
}: RsnSpinner.Props) {
    width = typeof width === 'number' ? asREM(width) : width;
    height = typeof height === 'number' ? asREM(height) : height;
    return (
        <svg viewBox='0 0 38 38' xmlns='http://www.w3.org/2000/svg' height={height} width={width}>
            <g transform='translate(3 3)'>
                <path
                    d='M32 16 c0-9.94-8.06-16-16-16'
                    strokeWidth='3'
                    fill='none'
                    stroke={customColor ?? themeColors[color]}
                >
                    <animateTransform
                        attributeName='transform'
                        type='rotate'
                        from='0 16 16'
                        to='360 16 16'
                        dur='1s'
                        repeatCount='indefinite'
                    ></animateTransform>
                </path>
            </g>
        </svg>
    );
}

export namespace RsnSpinner {
    export type Props = {
        w?: string | number;
        h?: string | number;
        color?: keyof typeof themeColors;
        customColor?: string;
    };
}
